import {
  Box,
  BoxProps,
  Button,
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  DrawerOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useDisclosure,
} from '@chakra-ui/react';
import { useResourceRelationship } from 'datx-jsonapi-react';
import { FC, useRef, useState } from 'react';

import DrawerIcon from '@/assets/icons/ic-drawer.svg';
import NotificationIcon from '@/assets/icons/ic-notification.svg';
import PeopleIcon from '@/assets/icons/ic-people.svg';

import { ChatPopup } from '@/components/ui/shared/chat/ChatPopup/ChatPopup';
import { NotificationBadge } from '@/components/ui/shared/notifications/NotificationBadge/NotificationBadge';
import { Notifications } from '@/components/ui/shared/notifications/Notifications/Notifications';
import { ErrorFallback } from '@/components/ui/shared/overlays/ErrorFallback/ErrorFallback';
import { BugsnagErrorBoundary } from '@/components/ui/shared/utilities/BugsnagErrorBoundary/BugsnagErrorBoundary';
import { ResourceType } from '@/enums/ResourceType';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { queryThinEventConfigurationRelationship } from '@/queries/thin-events';
import { EventConfiguration } from '@/resources/EventConfiguration';

export const SecondaryMenuMobile: FC<BoxProps> = ({ ...rest }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const btnRef = useRef();

  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const { data: eventConfiguration } = useResourceRelationship<EventConfiguration>(
    queryThinEventConfigurationRelationship(eventId)
  );

  return (
    <Box {...rest}>
      <Button ref={btnRef} onClick={onOpen} variant="nav" w="3.5rem" ml="auto">
        <NotificationBadge resourceType={[ResourceType.Lecture, ResourceType.EventChatChannel]}>
          <DrawerIcon />
        </NotificationBadge>
      </Button>

      <Drawer
        isOpen={isOpen}
        blockScrollOnMount={false}
        placement="right"
        onClose={onClose}
        finalFocusRef={btnRef}
        size="full"
      >
        <DrawerOverlay>
          <DrawerContent>
            <Tabs
              variant="nav"
              isLazy
              defaultIndex={selectedTabIndex}
              onChange={setSelectedTabIndex}
              display="flex"
              flexDirection="column"
            >
              <TabList>
                {eventConfiguration.directMessaging && (
                  <Tab>
                    <NotificationBadge refreshInterval={30_000} resourceType={ResourceType.EventChatChannel}>
                      <PeopleIcon />
                    </NotificationBadge>
                  </Tab>
                )}
                <Tab>
                  <NotificationBadge resourceType={ResourceType.Lecture}>
                    <NotificationIcon />
                  </NotificationBadge>
                </Tab>
                <DrawerCloseButton ml="auto" alignSelf="center" />
              </TabList>

              <TabPanels flex={1} minH={0}>
                {eventConfiguration.directMessaging && (
                  <TabPanel h="calc(100vh - 74px)" p={0}>
                    <ChatPopup />
                  </TabPanel>
                )}
                <TabPanel p={0}>
                  <BugsnagErrorBoundary FallbackComponent={ErrorFallback}>
                    <Notifications />
                  </BugsnagErrorBoundary>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </DrawerContent>
        </DrawerOverlay>
      </Drawer>
    </Box>
  );
};
